<app-data-table-component [headers]="headers" [currentSort]="'totalTrafficRatio'" [data]="pageReferrers"></app-data-table-component>

<ng-template #domainTemplate let-item='item'>
  <img class="mr-1" src="https://www.google.com/s2/favicons?domain={{ item }}" alt=""/> <span>{{ item }}</span>
</ng-template>
